import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

function useDocumentTitle(
  title: string,
  prefix = '',
  suffix = 'common.app-title'
) {
  const { t } = useTranslation()

  useEffect(() => {
    document.title = `${prefix} ${t(title)} - ${t(suffix)}`
  }, [t, title, prefix, suffix])
}

export default useDocumentTitle
